import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  TaglineTitle,
} from "./styles";

export default function SubEmployerHiringPackageInfo() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Start Hiring with These Benefits Today";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "pricing_page_benefits",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <TaglineTitle
          dangerouslySetInnerHTML={{ __html: solution?.title }}
        ></TaglineTitle>
      ))}

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => (
          <CardListContainer key={cardIndex} cardNumber={cardIndex}>
            <CardImage src={cards?.image?.data?.attributes?.url} />
            <CardTextContainer>
              <CardText
                type={"title"}
                cardNumber={cardIndex}
                dangerouslySetInnerHTML={{ __html: cards?.title }}
              ></CardText>
              <CardText
                type={"desc"}
                cardNumber={cardIndex}
                dangerouslySetInnerHTML={{ __html: cards?.description }}
              ></CardText>
            </CardTextContainer>
          </CardListContainer>
        ))}
      </CardContainer>

      <ButtonStyled onClick={triggerEmployerSignUp}>{buttonCTA}</ButtonStyled>
    </GridContainerStyled>
  );
}
